// inputs.js
import { validateRequired,validateLength, validateDateRange }from "../../../../helpers/validationsForm";

const Inputs = [
  {
    id: 1,
    name: "medida_descripcion",
    type: "text",
    label: "Nombre de la Medida",
    validation: (value, form) => {
      // Validación requerida
      const requiredError = validateRequired(value);
      if (requiredError) {
        return requiredError;
      }
    
      // Validación de longitud
      const lengthError = validateLength(value, { minLength: 3, maxLength: 40 });
      if (lengthError) {
        return lengthError;
      }
    
      // Si no hay errores
      return null;
    }    
  },
];

export default Inputs;
